import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookies (httpOnly) carry auth automatically thanks to withCredentials.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => `${API}/files/${path}`;

// Brand assets
export const BRAND = {
  logo: "https://customer-assets.emergentagent.com/job_hampton-blu-auto/artifacts/elro5rvy_9C3E711A-1B3F-46C0-B2BA-C963D460053D.png",
  hero: "https://customer-assets.emergentagent.com/job_hampton-blu-auto/artifacts/j666ed24_8DB54269-DD59-4D04-A1A5-0B697F1B8831.png",
};
